import { defineMessages } from 'react-intl';

export default defineMessages({
	documentTitle: {
		defaultMessage: 'Verify your email',
		description:
			'The text is shown as the browser document title on the email verification page, displayed in the browser tab after the user registers and is prompted to verify their email address.',
		id: 'cv.sign.up.check.email.document.title',
	},
	emailSentSuccessMessage: {
		defaultMessage: 'Email sent to {emailAddress}',
		description:
			'The text is shown in a success notification after the user requests a verification email resend. The placeholder {emailAddress} will be substituted with the recipient email address.',
		id: 'cv.sign.up.check.email.resend.success.message',
	},
	checkEmailToFinishSignup: {
		defaultMessage: 'Check your email to set your password',
		description:
			'The text is shown as the main heading on the sign-up email verification page, instructing the user to check their inbox to complete the password setup process.',
		id: 'cv.sign.up.check.your.email.to.signup',
	},
	emailSentHint: {
		defaultMessage: "We've sent information on how to set your password to {emailAddress}.",
		description:
			'help text to explain that and email has been sent and that the user has to check his inbox',
		id: 'cv.sign.up.check.email.sub.title',
	},
	resendSignupLink: {
		defaultMessage: 'Resend password setup link',
		description:
			'The text is shown on a button on the email verification page that allows the user to resend the password setup email if they did not receive it.',
		id: 'cv.sign.up.resend.signup.link.button',
	},
});
